import IconLogo from '@/components/_rebrand/IconLogo';
import Confirmation from '@/components/RequestDemo/Confirmation';
import DemoFormStepOne from '@/components/RequestDemo/DemoFormStepOne';
import DemoFormStepTwo from '@/components/RequestDemo/DemoFormStepTwo';
import QualifiedSchedulerStep from '@/components/RequestDemo/QualifiedSchedulerStep';
import { DemoFormSteps, useDemoFormSteps } from '@/components/RequestDemo/useDemoFormSteps';
import { HubspotFieldNames } from '@/constants/hubspot';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { NextRouter } from 'next/router';
import { FC, useEffect, useState, useTransition } from 'react';
import styled from 'styled-components';
import ModalComponent, { StyledModalContainer } from '../Modal';
import DemoSocialProofContent from './DemoSocialProofContent';

// Regrettably doing this via styled-components to override the max-width and padding
const StyledModal = styled(ModalComponent)`
  --modal-max-width: 1084px;
  --modal-padding: 0;

  ${StyledModalContainer} {
    overflow: hidden;
  }
`;

interface DemoModalContentProps {
  router: NextRouter | AppRouterInstance;
  onClose: () => void;
}


const DemoModalContent: FC<DemoModalContentProps> = ({ router, onClose }) => {
  const { currentStep, demoStepOneFormData, demoStepTwoFormData, meetingOffered, setCurrentStep, incrementInitialDemoFormStep, incrementSecondaryDemoFormStep } = useDemoFormSteps();
  const [navigationTriggered, setNavigationTriggered] = useState(false);
  const [navigationPending, startNavigation] = useTransition();

  // Workaround to close modal after navigation b/c AppRouter does not return a promise after .push()
  useEffect(() => {
    if (navigationPending) {
      setNavigationTriggered(true);
    }
    if (!navigationPending && navigationTriggered) {
      onClose();
    }
  }, [navigationPending, navigationTriggered]);

  return (
    <StyledModal
      name="Demo Modal"
      onClose={() => {
        onClose();
      }}
    >
      <div className='grid grid-cols-1 md:grid-cols-2'>
        <div className='p-3 md:p-4 lg:p-[42px] relative flex flex-col'>
          <IconLogo width={75} height={25} />
          {currentStep === DemoFormSteps.FormStepOne && (
            <>
              <h3 className='text-h4 font-600 mt-3'>Get a personalized demo</h3>
              <p className='text-caption2 font-500 mt-1 mb-3'>Help us tailor the demo experience to your needs.</p>
              <DemoFormStepOne
                onDemoFormOneSuccess={(values) => incrementInitialDemoFormStep(values)}
              />
            </>
          )}
          {currentStep === DemoFormSteps.FormStepTwo && demoStepOneFormData && (
            <>
              <div className="text-h4 font-600 mt-3">Tell us a little more about yourself</div>
              <div className="text-caption2 text-blue-1000 font-500 mt-1">So we can show you how Front can address your business needs.</div>
              <div className="text-caption2 font-500  text-red-500  mt-1 mb-3">Note: Your request is not complete until you submit this form.</div>
              <DemoFormStepTwo
                initialValues={demoStepOneFormData}
                onDemoFormTwoSuccess={(values, meetingOffered) => incrementSecondaryDemoFormStep(values, meetingOffered)}
              />
            </>
          )}
          {currentStep === DemoFormSteps.Scheduler && demoStepTwoFormData && (
            <QualifiedSchedulerStep
              formFields={demoStepTwoFormData}
              meetingBookedCallback={() => {
                setCurrentStep(DemoFormSteps.Confirmation);
              }}
              onClose={onClose}
            />
          )}
          {currentStep === DemoFormSteps.Confirmation && demoStepTwoFormData && (
            <Confirmation userFirstName={demoStepTwoFormData?.[HubspotFieldNames.FirstName]} onClose={onClose} meetingOffered={meetingOffered} />
          )}

        </div>
        <DemoSocialProofContent />
      </div>
    </StyledModal>
  );
};

export default DemoModalContent;
